import React from 'react'
import {useLocation} from 'react-router-dom'
import { Detail ,Dojo , Demand } from '../../component/fiture'
import {Courses} from '../../assets/img'
import './course.scss'
// 


function Index() {
    
    const {search} = useLocation()

    const params = new URLSearchParams(search)

    const Scroll = () => window.scrollTo({behavior : 'smooth' , top : 0})
    

    return (
        // 
        params.get('id') !== null ? 
        
        <Detail id={params.get('id')} />  : 

            <div className='courses'>
                <div className='jumbotron' style={{backgroundImage : `url(${Courses})`}}>
                    <h3 className='title'>COURSES</h3>
                </div>

                <div className='content-wrapper'>
                    <div className='course-title'>
                        <h3 className='title'>Dattabot Dojo Programs</h3>
                        <Dojo />
                    </div>
                    <div className='course-title'>
                        <h3 className='title'>Most In Demand</h3>
                        <Demand />
                    </div>
                </div>
                <span className='back' onClick={Scroll}>Kembali Ke Atas</span>
            </div>
    )
}

export default Index
